import React, { useContext, useEffect } from "react";
import ProjectListSideBar from "./ProjectListSideBar";
import TaskList from "./TaskList";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useGetProjects } from "../ProjectList/projectHooks";
import { AuthContext } from "../../../../context/authContext";
import { useParams } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const ProjectTasksPage = () => {
  const { projectId } = useParams("projectId");
  const { accessToken } = useContext(AuthContext);
  const {
    data,
    isError: isLoadingItemsError,
    isFetching,
    isLoading,
  } = useGetProjects({ accessToken });
  const [selectedProject, setSelectedProject] = useState({});

  useEffect(() => {
    if (data) {
      let selectedProjectData = data.find(
        (project) => project.id === parseInt(projectId)
      );
      // console.log("selected data ", selectedProjectData, projectId);

      setSelectedProject(selectedProjectData);
      // console.log("selectedddd", selectedProjectData);
    }
  }, [projectId, data]);

  if (data)
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>

        <Box
          sx={{
            margin: "16px  12px 12px 12px",
          }}
        >
          <Typography variant="h5">{selectedProject.projectName}</Typography>
          {/* <ProjectListSideBar
          projects={data}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
        /> */}
          <TaskList
            selectedProject={selectedProject}
          />
        </Box>
      </LocalizationProvider>
    );
};

export default ProjectTasksPage;
